import React from 'react';
import { TextInput, required, FileInput, FileField } from 'react-admin';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';

// eslint-disable-next-line react/prop-types
const ScormForm = ({ nameLabel, fileName }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={12} md={12}>
      <TextInput
        source="fileName"
        label={nameLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={12}>
      <FileInput
        accept="application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream"
        fullWidth
        labelSingle={fileName}
        source="file"
        validate={required()}
        maxSize={80000000}
      >
        <FileField src="preview" source="previewUrl" title="title" />
      </FileInput>
    </Grid>
  </Grid>
);

ScormForm.propTypes = {
  nameLabel: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
};

export default ScormForm;
